/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_CompleteInputs */

const id_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selesai`)
};

const ms_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selesai`)
};

const da_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fuldført`)
};

const de_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abgeschlossen`)
};

const en_us2_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complete`)
};

const es_es2_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completado`)
};

const es_mx2_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completado`)
};

const fil_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kumpleto`)
};

const fr_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terminé`)
};

const it_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completato`)
};

const hu_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kész`)
};

const nl_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voltooid`)
};

const no_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fullført`)
};

const pl_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ukończone`)
};

const pt_br2_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completo`)
};

const pt_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`completo`)
};

const ro_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complet`)
};

const fi_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`valmis`)
};

const sv_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slutförd`)
};

const vi_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hoàn thành`)
};

const tr_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tamamlandı`)
};

const cs_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dokončeno`)
};

const bg_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`завършено`)
};

const ru_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`пройдено`)
};

const uk_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`завершено`)
};

const ar_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكتمل`)
};

const hi_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण`)
};

const th_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมบูรณ์`)
};

const ja_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const zh_cn2_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成`)
};

const zh_hant1_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成`)
};

const ko_profile_hero_complete = /** @type {(inputs: Profile_Hero_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료`)
};

/**
* | output |
* | --- |
* | "complete" |
*
* @param {Profile_Hero_CompleteInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_complete = /** @type {((inputs?: Profile_Hero_CompleteInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_CompleteInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_complete(inputs)
	if (locale === "ms") return ms_profile_hero_complete(inputs)
	if (locale === "da") return da_profile_hero_complete(inputs)
	if (locale === "de") return de_profile_hero_complete(inputs)
	if (locale === "en-US") return en_us2_profile_hero_complete(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_complete(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_complete(inputs)
	if (locale === "fil") return fil_profile_hero_complete(inputs)
	if (locale === "fr") return fr_profile_hero_complete(inputs)
	if (locale === "it") return it_profile_hero_complete(inputs)
	if (locale === "hu") return hu_profile_hero_complete(inputs)
	if (locale === "nl") return nl_profile_hero_complete(inputs)
	if (locale === "no") return no_profile_hero_complete(inputs)
	if (locale === "pl") return pl_profile_hero_complete(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_complete(inputs)
	if (locale === "pt") return pt_profile_hero_complete(inputs)
	if (locale === "ro") return ro_profile_hero_complete(inputs)
	if (locale === "fi") return fi_profile_hero_complete(inputs)
	if (locale === "sv") return sv_profile_hero_complete(inputs)
	if (locale === "vi") return vi_profile_hero_complete(inputs)
	if (locale === "tr") return tr_profile_hero_complete(inputs)
	if (locale === "cs") return cs_profile_hero_complete(inputs)
	if (locale === "bg") return bg_profile_hero_complete(inputs)
	if (locale === "ru") return ru_profile_hero_complete(inputs)
	if (locale === "uk") return uk_profile_hero_complete(inputs)
	if (locale === "ar") return ar_profile_hero_complete(inputs)
	if (locale === "hi") return hi_profile_hero_complete(inputs)
	if (locale === "th") return th_profile_hero_complete(inputs)
	if (locale === "ja") return ja_profile_hero_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_complete(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_complete(inputs)
	return ko_profile_hero_complete(inputs)
});
export { profile_hero_complete as "profile.hero.complete" }